import React, { useState, useEffect, useCallback, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormCheck from 'react-bootstrap/FormCheck';
import Button from 'react-bootstrap/Button';
import { MDBCheckbox } from 'mdb-react-ui-kit';
import ReCAPTCHA from "react-google-recaptcha";
//constants
import Url from '../constants/Url';
//style
import '../styles/contactForm.css';
//axios
import axios from 'axios';
import MyAlert from "./Alert";


const ContactForm = props => {

  const captchaRef = useRef(null);


  const [from, setFrom] = useState("contact@leadev.fr");
  const [to, setTo] = useState("pascal.garnier74@orange.fr");
  const [email, setEmail] = useState("");
  const [nom, setNom] = useState("");
  const [phone, setPhone] = useState("");
  const artworkSelected = useSelector(state => state.typologies.artworkSelected);

  const [message, setMessage] = React.useState("Veuillez renseigner l'ensemble des champs du formulaire.");
  const [successMessage, setSuccessMessage] = React.useState("");
  const [error, setError] = React.useState("");
  const [status, setStatus] = React.useState("INIT");

  const [subject, setSubject] = useState(artworkSelected!==null?`GARNER - Réalisation : ${artworkSelected.titreOeuvre}`:"Website");
  const [text, setText] = useState(artworkSelected!==null?`Bonjour, je souhaiterai en savoir plus sur votre travail : ${artworkSelected.titreOeuvre}, pourriez-vous me recontacter s'il vous plaît ?`:"Bonjour, je suis intéressé(e) par vos réalisations ...");


  const sendMailTo = async() => {
    console.log(from+" "+to+" "+subject+" "+text);


    let status ="";
    const msg = {to: `${to}`,from: `${from}`,subject: `${subject}`,text: `${text}`};

    await axios.post(`${Url.garner_Api}contact`, msg)
    .then(res => status = "OK")
    .catch(err => status ="KO");

    
  
    if(status==="OK"){
      setMessage("");
      setSuccessMessage("Votre message a bien été envoyé");
      setNom("");
      setEmail("");
      setSubject("");
      setPhone("");
      setError("");
      
    }else{
      setError("Une erreur est intervenue lors de l'envoi de votre message. Veuillez vérifier le formulaire.");
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (

    <Container lg={{offset:3,span:6, offset:3}}>
    <Form>

    <Row className="mb-3">
    {
      status !== "KO"  ?
      <h4 className="init">{message} {successMessage} </h4>
      :
      <h4 className="error">{error}</h4>
    }

    </Row>


    <Row className="mb-3">
      <Form.Group as={Col} controlId="formGridNom">
        <Form.Label className="myformlabel">NOM Prénom</Form.Label>
        <Form.Control type="input" placeholder="Votre identité"
        className="myforminput"
        value={nom} onChange={(e)=>setNom(e.target.value)} />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridEmail">
        <Form.Label className="myformlabel">Email</Form.Label>
        <Form.Control type="email" placeholder="Email"
        className="myforminput"
        value={email} onChange={(e)=>setEmail(e.target.value)} />
      </Form.Group>
    </Row>

    <Row className="mb-3">
      <Form.Group as={Col} controlId="formGridSubject">
        <Form.Label className="myformlabel">Sujet</Form.Label>
        <Form.Control type="input" placeholder="Sujet"
        className="myforminput"
        value={subject} onChange={(e)=>setSubject(e.target.value)} />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridPhone">
        <Form.Label className="myformlabel">Téléphone</Form.Label>
        <Form.Control type="input" placeholder="Telephone"
        className="myforminput"
        value={phone} onChange={(e)=>setPhone(e.target.value)} />
      </Form.Group>
    </Row>

    <Row className="mb-3">
      <Form.Group as={Col} controlId="formGridMessage">
      <Form.Label className="myformlabel">Message</Form.Label>
      <Form.Control as="textarea" row={3} placeholder="Telephone"
      className="myforminput"
      value={text} onChange={(e)=>setText(e.target.value)} />
      </Form.Group>
    </Row>

    <Row className="mb-3">
    </Row>

    <Row className="mb-3">
    </Row>





      <Button type="button" variant="primary" onClick={()=>sendMailTo()} className="btnFormSend">
      <span className="btn-envoyer">Envoyer</span>
      <reCAPTCHA
      sitekey={process.env.REACT_APP_SITE_KEY}
      ref={captchaRef}
      />
      </Button>
    </Form>
    </Container>

  )

}

export default ContactForm;
